// 企業マイページ共通js

/*
 * 1つでもチェックがあったらinputのrequiredを削除 小グループがあるもの
	(他の項目でエラーがあった時に必要)
 */
$(window).on('load', function () {
	$('.field-checkbox-input:checked').parent().parent('.form-group.input-item').find('.field-checkbox-input').removeAttr("required");
	$('.field-checkbox-input:checked').parent().parent().parent().parent('.edit-box').find('.field-checkbox-input').removeAttr("required");
	// ▼開催場所（都道府県+WEB）
	$('.internship-state-checkbox .field-checkbox-input:checked').closest('.internship-state-checkbox').find('.field-checkbox-input').removeAttr("required");
});

/*
 * 1つでもチェックがあったらinputのrequiredを削除 小グループがないもの
 */
$(window).on('load', function () {
	$('.field-checkbox-input:checked').parent().parent().parent('.form-group.input-item').find('.field-checkbox-input').removeAttr("required");
});


/*
 * チェックボックス required制御 企業マイページ 製品新規登録ページ 小グループがないもの
 */
jQuery(function ($) {
	if ($('.form-group.input-item .field-checkbox-label').length) {
		$('.form-group.input-item .field-checkbox-label').on('click', function () {
			let label = $(this).parent().parent('.form-group.input-item').children('label');

			if (label.children().is('.required')) {//必須マークがあったら
				let checkedsum; //チェックが入っている個数
				checkedsum = $(this).parent().parent('.form-group.input-item').find('.field-checkbox-input:checked').length; //チェックが入っているチェックボックスの取得
				if (checkedsum > 0) {//1つでもチェックが入ったらrequired属性削除
					$(this).parent().parent('.form-group.input-item').find('.field-checkbox-input').removeAttr("required"); //required属性の解除
				} else {//チェックが0になったらrequired属性付与
					$(this).parent().parent('.form-group.input-item').find('.field-checkbox-input').prop("required", true); //required属性の付与
				};
			}
		});
	};
});

/*
 * チェックボックス required制御 企業マイページ 小グループがあるもの（会社情報の業界など）
 */
jQuery(function($) {
	if($('.edit-box').length) {
		$('.field-checkbox-label').on('click',function() {
			let label = $(this).parent().parent().parent().parent('.form-group.input-item').children('label');
			if (label.children().is('.required')) {//必須マークがあったら
				let checkedsum; //チェックが入っている個数
				checkedsum = $(this).parent().parent().parent().parent('.form-group.input-item').find('.field-checkbox-input:checked').length; //チェックが入っているチェックボックスの取得
				if( checkedsum > 0 ){//1つでもチェックが入ったらrequired属性削除
					$(this).parent().parent().parent().parent('.form-group.input-item').find('.field-checkbox-input').prop('formnovalidate',true).removeAttr("required"); //required属性の解除
				}else{//チェックが0になったらrequired属性付与
					$(this).parent().parent().parent().parent('.form-group.input-item').find('.field-checkbox-input').prop("required",true); //required属性の付与
				};
			};
		});
	};
});
